export default __webpack_public_path__ + "static/media/inspire_web-lg@2x.ba828f73.jpg";